<template>
    <nav>
        <ul>
            <li class="flexbox-center" :class="{'active': selectedView === 'administration-my-profile'}">
                <a @click="changeAdministrationView('administration-my-profile')">
                    <div class="navigation-icon"><icon name="user" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">{{userInfo.name}}</div>
                </a>
            </li>
            <li v-if="permission.organization.enabled" class="flexbox-center" :class="{'active': selectedView === 'administration-my-organisation'}" @click="changeAdministrationView('administration-my-organisation')">
                <a>
                    <div class="navigation-icon"><icon name="group" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">{{selectedOrganization.name}}</div>
                </a>
            </li>
            <li v-if="permission.companies.enabled" class="flexbox-center" :class="{'active': selectedView === 'administration-my-companies'}" @click="changeAdministrationView('administration-my-companies')">
                <a>
                    <div class="navigation-icon"><icon name="building" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">Virksomheder</div>
                </a>
            </li>
             <li v-if="permission.configdrive.enabled" class="flexbox-center" :class="{'active': selectedView === 'administration-my-selectlists'}" @click="changeAdministrationView('administration-my-selectlists')">
                <a>
                    <div class="navigation-icon"><icon name="drop-down-list" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">Værdilister</div>
                </a>
            </li>
            <li v-if="permission.configdrive.enabled" class="flexbox-center" :class="{'active': selectedView === 'administration-my-userinterface'}" @click="changeAdministrationView('administration-my-userinterface')">
                <a>
                    <div class="navigation-icon"><icon name="ui-design" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">Indstillinger</div>
                </a>
            </li>
            <li v-if="permission.configdrive.enabled" class="flexbox-center" :class="{'active': selectedView === 'administration-my-userlog'}" @click="changeAdministrationView('administration-my-userlog')">
                <a>
                    <div class="navigation-icon"><icon name="log" class="medium-svg fill-selected-dark-gray" /></div>
                    <div class="navigation-text">Log</div>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data () {
            return {
            }
        },
        computed: {
            ...mapGetters({
                userInfo: 'userInfo',
                selectedView: 'getAdministrationView',
                permission: 'permissions',
                selectedOrganization: 'getSelectedOrganization'
            })
        },
        methods: {
            ...mapActions({
                setAdministrationView: 'setAdministrationView'
            }),
            changeAdministrationView (view) {
                this.setAdministrationView(view)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-left-nav.vue